import lcRequest from '../index'

// 登录
export function accountLogin(account) {
  return lcRequest.post({
    url: '/index/index/login',
    data: account,
    showLoading: true
  })
}

// 注册
export function register(data) {
  return lcRequest.post({
    url: '/index/index/register',
    data
  })
}

// 重置密码
export function resetPassword(data) {
  return lcRequest.post({
    url: '/index/index/resetpwd',
    data
  })
}

// 发送邮箱验证码
export function getCheckCode(data) {
  return lcRequest.post({
    url: '/index/index/sendemail',
    data
  })
}
